import { ExperienceTransferTranslation, queryFilters } from 'app/area/experience-transfer/constants';
import { ComplexValue } from 'app/types-shared';

export const experienceTransferQueryFilters = (translation: ExperienceTransferTranslation): ComplexValue<string>[] => [
  { value: queryFilters.subscriberGroup, description: translation.subscriber_group },
  { value: queryFilters.criteria, description: translation.criteria }
];
